import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

export function LoginPage({ onSuccess, onBack }) {
  const { loginAdmin } = useAuth();
  const [form, setForm] = useState({ username:'', password:'' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault(); setError(''); setLoading(true);
    try { await loginAdmin(form.username, form.password); onSuccess(); }
    catch(e) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-wrap">
      <div className="login-box">
        <div className="login-logo"><img src="/logo.png" alt="Brokalia" onError={e=>e.target.style.display='none'} /></div>
        <h2 className="login-title">Panel de administración</h2>
        <p className="login-sub">Acceso restringido · equipo Brokalia</p>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Usuario</label>
            <input className="form-input" value={form.username} onChange={e=>setForm(f=>({...f,username:e.target.value}))} placeholder="admin" required />
          </div>
          <div className="form-group">
            <label className="form-label">Contraseña</label>
            <input className="form-input" type="password" value={form.password} onChange={e=>setForm(f=>({...f,password:e.target.value}))} placeholder="••••••••" required />
          </div>
          <button className="btn btn-primary" type="submit" style={{ width:'100%', justifyContent:'center', marginTop:8 }} disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar al panel'}
          </button>
        </form>
        <button onClick={onBack} style={{ background:'none',border:'none',cursor:'pointer',color:'var(--light)',fontSize:12,marginTop:16,display:'block',width:'100%',textAlign:'center' }}>
          ← Volver al portal
        </button>
      </div>
    </div>
  );
}

export function AdminPanel({ onExit }) {
  const { adminUser, clearAdmin, authFetch, authFetchForm } = useAuth();
  const [section, setSection] = useState('empresa');

  const navItems = [
    { id:'empresa', label:'📋 Empresa', group:'Contenido' },
    { id:'personas', label:'👤 Personas', group:'Contenido' },
    { id:'departamentos', label:'🏢 Departamentos', group:'Contenido' },
    { id:'accesos', label:'🔐 Contraseñas', group:'Seguridad' },
  ];
  const groups = [...new Set(navItems.map(i=>i.group))];

  return (
    <div>
      <nav className="nav">
        <div className="nav-logo"><img src="/logo.png" alt="Brokalia" onError={e=>e.target.style.display='none'} /></div>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <span style={{ fontSize:12, color:'var(--mid)' }}>Admin: {adminUser}</span>
          <button className="btn btn-outline btn-sm" onClick={onExit}>← Portal</button>
          <button className="btn btn-outline btn-sm" onClick={() => { clearAdmin(); onExit(); }}>Cerrar sesión</button>
        </div>
      </nav>
      <div className="admin-layout">
        <aside className="admin-sidebar">
          {groups.map(g => (
            <div key={g}>
              <p className="admin-sidebar-title" style={{ marginTop:16 }}>{g}</p>
              {navItems.filter(i=>i.group===g).map(item => (
                <button key={item.id} className={`admin-nav-btn${section===item.id?' active':''}`} onClick={()=>setSection(item.id)}>
                  {item.label}
                </button>
              ))}
              <div className="admin-divider" />
            </div>
          ))}
        </aside>
        <main className="admin-content">
          {section==='empresa'      && <AdminEmpresa authFetch={authFetch} />}
          {section==='personas'     && <AdminPersonas authFetch={authFetch} authFetchForm={authFetchForm} />}
          {section==='departamentos'&& <AdminDepartamentos authFetch={authFetch} />}
          {section==='accesos'      && <AdminAccesos authFetch={authFetch} />}
        </main>
      </div>
    </div>
  );
}

function AdminEmpresa({ authFetch }) {
  const [data, setData] = useState(null);
  const [msg, setMsg] = useState('');
  useEffect(() => { fetch('/api/company').then(r=>r.json()).then(setData); }, []);
  const toast = m => { setMsg(m); setTimeout(()=>setMsg(''),3000); };
  if (!data) return <div className="loading"><div className="spinner" /></div>;
  const co = data.company;

  return (
    <div>
      <div className="admin-header"><h2>Empresa</h2></div>
      {msg && <div className="alert alert-success">{msg}</div>}
      <div className="card" style={{ marginBottom:16 }}>
        <h3 style={{ fontWeight:600, marginBottom:16 }}>Textos principales</h3>
        <div className="form-group">
          <label className="form-label">Texto de bienvenida</label>
          <textarea className="form-textarea" rows={4} value={co?.welcome_text||''} onChange={e=>setData(d=>({...d,company:{...d.company,welcome_text:e.target.value}}))} />
        </div>
        <div className="form-group">
          <label className="form-label">Misión</label>
          <textarea className="form-textarea" rows={4} value={co?.mission_text||''} onChange={e=>setData(d=>({...d,company:{...d.company,mission_text:e.target.value}}))} />
        </div>
        <h4 style={{ fontWeight:600, marginBottom:12, marginTop:16 }}>KPIs de estadísticas</h4>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:10 }}>
          {[1,2,3,4].map(n => (
            <div key={n} style={{ display:'flex', gap:6 }}>
              <div style={{ flex:'0 0 70px' }}>
                <label className="form-label">Núm.</label>
                <input className="form-input" value={co?.[`stat${n}_num`]||''} onChange={e=>setData(d=>({...d,company:{...d.company,[`stat${n}_num`]:e.target.value}}))} />
              </div>
              <div style={{ flex:1 }}>
                <label className="form-label">Etiqueta</label>
                <input className="form-input" value={co?.[`stat${n}_label`]||''} onChange={e=>setData(d=>({...d,company:{...d.company,[`stat${n}_label`]:e.target.value}}))} />
              </div>
            </div>
          ))}
        </div>
        <button className="btn btn-primary btn-sm" style={{ marginTop:16 }} onClick={async()=>{await authFetch('/api/company',{method:'PUT',body:JSON.stringify(data.company)});toast('✅ Guardado');}}>Guardar cambios</button>
      </div>

      <div className="card" style={{ marginBottom:16 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
          <h3 style={{ fontWeight:600 }}>Propuesta de valor</h3>
          <button className="btn btn-outline btn-sm" onClick={()=>setData(d=>({...d,values:[...d.values,{title:'',description:''}]}))}>+ Añadir</button>
        </div>
        {data.values.map((v,i) => (
          <div key={i} style={{ display:'flex', gap:10, marginBottom:10 }}>
            <div style={{ flex:1 }}>
              <input className="form-input" placeholder="Título" value={v.title} style={{ marginBottom:5 }} onChange={e=>{const vs=[...data.values];vs[i]={...vs[i],title:e.target.value};setData(d=>({...d,values:vs}));}} />
              <input className="form-input" placeholder="Descripción" value={v.description} onChange={e=>{const vs=[...data.values];vs[i]={...vs[i],description:e.target.value};setData(d=>({...d,values:vs}));}} />
            </div>
            <button className="btn-icon" onClick={()=>setData(d=>({...d,values:d.values.filter((_,j)=>j!==i)}))}>🗑</button>
          </div>
        ))}
        <button className="btn btn-primary btn-sm" style={{ marginTop:8 }} onClick={async()=>{await authFetch('/api/company/values',{method:'PUT',body:JSON.stringify({items:data.values})});toast('✅ Propuesta de valor guardada');}}>Guardar</button>
      </div>

      <div className="card">
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
          <h3 style={{ fontWeight:600 }}>Historia</h3>
          <button className="btn btn-outline btn-sm" onClick={()=>setData(d=>({...d,history:[...d.history,{title:'',content:''}]}))}>+ Añadir bloque</button>
        </div>
        {data.history.map((h,i) => (
          <div key={i} style={{ marginBottom:14, paddingBottom:14, borderBottom:'1px solid var(--border)' }}>
            <div style={{ display:'flex', gap:10 }}>
              <div style={{ flex:1 }}>
                <input className="form-input" placeholder="Título del bloque" value={h.title} style={{ marginBottom:6 }} onChange={e=>{const hs=[...data.history];hs[i]={...hs[i],title:e.target.value};setData(d=>({...d,history:hs}));}} />
                <textarea className="form-textarea" rows={3} value={h.content} onChange={e=>{const hs=[...data.history];hs[i]={...hs[i],content:e.target.value};setData(d=>({...d,history:hs}));}} />
              </div>
              <button className="btn-icon" onClick={()=>setData(d=>({...d,history:d.history.filter((_,j)=>j!==i)}))}>🗑</button>
            </div>
          </div>
        ))}
        <button className="btn btn-primary btn-sm" onClick={async()=>{await authFetch('/api/company/history',{method:'PUT',body:JSON.stringify({blocks:data.history})});toast('✅ Historia guardada');}}>Guardar historia</button>
      </div>
    </div>
  );
}

function AdminPersonas({ authFetch, authFetchForm }) {
  const [people, setPeople] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [editing, setEditing] = useState(null);
  const [msg, setMsg] = useState('');
  const load = () => { fetch('/api/people').then(r=>r.json()).then(setPeople); fetch('/api/departments').then(r=>r.json()).then(setDepartments); };
  useEffect(load,[]);
  const toast = m => { setMsg(m); setTimeout(()=>setMsg(''),3000); };

  const save = async () => {
    const method = editing.id?'PUT':'POST';
    const url = editing.id?`/api/people/${editing.id}`:'/api/people';
    await authFetch(url,{method,body:JSON.stringify(editing)});
    setEditing(null); load(); toast('✅ Persona guardada');
  };
  const del = async id => { if(!window.confirm('¿Eliminar?')) return; await authFetch(`/api/people/${id}`,{method:'DELETE'}); load(); };
  const swapOrder = async (i, j) => {
    const a = people[i], b = people[j];
    await Promise.all([
      authFetch(`/api/people/${a.id}`,{method:'PUT',body:JSON.stringify({...a,display_order:b.display_order})}),
      authFetch(`/api/people/${b.id}`,{method:'PUT',body:JSON.stringify({...b,display_order:a.display_order})}),
    ]);
    load();
  };
  const uploadPhoto = async (id, file) => {
    const fd = new FormData(); fd.append('photo',file);
    const res = await authFetchForm('/api/upload/photo',{method:'POST',body:fd});
    const d = await res.json();
    if(d.url){ await authFetch(`/api/people/${id}/photo`,{method:'PATCH',body:JSON.stringify({photo_url:d.url})}); load(); toast('✅ Foto actualizada'); }
  };
  const blank = { name:'',role:'',email:'',initials:'',department_id:'',is_director:false,bio:'',display_order:0,functions:[{title:'',description:''}] };

  return (
    <div>
      <div className="admin-header"><h2>Personas</h2><button className="btn btn-primary btn-sm" onClick={()=>setEditing(blank)}>+ Nueva persona</button></div>
      {msg && <div className="alert alert-success">{msg}</div>}
      {editing && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setEditing(null)}>
          <div className="modal modal-lg fade-in">
            <div className="modal-header"><h3>{editing.id?'Editar persona':'Nueva persona'}</h3><button className="modal-close" onClick={()=>setEditing(null)}>×</button></div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group"><label className="form-label">Nombre</label><input className="form-input" value={editing.name} onChange={e=>setEditing(p=>({...p,name:e.target.value}))} /></div>
                <div className="form-group"><label className="form-label">Iniciales</label><input className="form-input" placeholder="Auto" value={editing.initials} onChange={e=>setEditing(p=>({...p,initials:e.target.value}))} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label className="form-label">Cargo</label><input className="form-input" value={editing.role} onChange={e=>setEditing(p=>({...p,role:e.target.value}))} /></div>
                <div className="form-group"><label className="form-label">Email</label><input className="form-input" type="email" value={editing.email} onChange={e=>setEditing(p=>({...p,email:e.target.value}))} /></div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Departamento</label>
                  <select className="form-select" value={editing.department_id||''} onChange={e=>setEditing(p=>({...p,department_id:e.target.value||null}))}>
                    <option value="">Sin departamento (CEO / DG)</option>
                    {departments.map(d=><option key={d.id} value={d.id}>{d.name}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Rol</label>
                  <label style={{ display:'flex',alignItems:'center',gap:8,marginTop:10,cursor:'pointer' }}>
                    <input type="checkbox" checked={!!editing.is_director} onChange={e=>setEditing(p=>({...p,is_director:e.target.checked}))} />
                    <span style={{ fontSize:13,color:'var(--mid)' }}>Es director/a</span>
                  </label>
                </div>
              </div>
              <div className="form-group"><label className="form-label">Bio (opcional)</label><textarea className="form-textarea" rows={2} value={editing.bio} onChange={e=>setEditing(p=>({...p,bio:e.target.value}))} /></div>
              <div>
                <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8 }}>
                  <label className="form-label" style={{ margin:0 }}>Funciones</label>
                  <button className="btn btn-outline btn-sm" onClick={()=>setEditing(p=>({...p,functions:[...(p.functions||[]),{title:'',description:''}]}))}>+</button>
                </div>
                {(editing.functions||[]).map((f,i) => (
                  <div key={i} style={{ display:'flex',gap:8,marginBottom:8 }}>
                    <div style={{ flex:1 }}>
                      <input className="form-input" placeholder="Título" value={f.title} style={{ marginBottom:4 }} onChange={e=>{const fs=[...editing.functions];fs[i]={...fs[i],title:e.target.value};setEditing(p=>({...p,functions:fs}));}} />
                      <input className="form-input" placeholder="Descripción" value={f.description} onChange={e=>{const fs=[...editing.functions];fs[i]={...fs[i],description:e.target.value};setEditing(p=>({...p,functions:fs}));}} />
                    </div>
                    <button className="btn-icon" onClick={()=>setEditing(p=>({...p,functions:p.functions.filter((_,j)=>j!==i)}))}>🗑</button>
                  </div>
                ))}
              </div>
              <div style={{ display:'flex',gap:8,justifyContent:'flex-end',marginTop:16 }}>
                <button className="btn btn-outline" onClick={()=>setEditing(null)}>Cancelar</button>
                <button className="btn btn-primary" onClick={save}>Guardar</button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead><tr><th>Orden</th><th>Persona</th><th>Cargo</th><th>Departamento</th><th>Foto</th><th>Acciones</th></tr></thead>
          <tbody>
            {people.map((p,i) => (
              <tr key={p.id}>
                <td>
                  <div style={{ display:'flex',gap:2 }}>
                    <button className="btn-icon" disabled={i===0} style={i===0?{opacity:.3,cursor:'default'}:undefined} onClick={()=>swapOrder(i,i-1)}>↑</button>
                    <button className="btn-icon" disabled={i===people.length-1} style={i===people.length-1?{opacity:.3,cursor:'default'}:undefined} onClick={()=>swapOrder(i,i+1)}>↓</button>
                  </div>
                </td>
                <td><div className="table-name-cell"><div className="table-avatar">{p.photo_url?<img src={p.photo_url} alt={p.name}/>:p.initials}</div><span className="name-cell">{p.name}</span>{p.is_director===1&&<span className="badge badge-brand">Dir.</span>}</div></td>
                <td>{p.role}</td>
                <td>{p.dept_name||<span style={{ color:'var(--light)' }}>—</span>}</td>
                <td><label style={{ cursor:'pointer' }}><span className="btn btn-outline btn-sm" style={{ display:'inline-flex' }}>📷 Subir</span><input type="file" accept="image/*" style={{ display:'none' }} onChange={e=>e.target.files[0]&&uploadPhoto(p.id,e.target.files[0])} /></label></td>
                <td><div className="actions"><button className="btn-icon" onClick={()=>setEditing({...p,functions:p.functions||[]})}>✏️</button><button className="btn-icon" onClick={()=>del(p.id)}>🗑</button></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function AdminDepartamentos({ authFetch }) {
  const [depts, setDepts] = useState([]);
  const [editing, setEditing] = useState(null);
  const [msg, setMsg] = useState('');
  const load = () => fetch('/api/departments').then(r=>r.json()).then(setDepts);
  useEffect(load,[]);
  const toast = m => { setMsg(m); setTimeout(()=>setMsg(''),3000); };
  const save = async () => { const method=editing.id?'PUT':'POST'; const url=editing.id?`/api/departments/${editing.id}`:'/api/departments'; await authFetch(url,{method,body:JSON.stringify(editing)}); setEditing(null); load(); toast('✅ Departamento guardado'); };
  const del = async id => { if(!window.confirm('¿Eliminar departamento?')) return; await authFetch(`/api/departments/${id}`,{method:'DELETE'}); load(); };
  const blank = { name:'',icon:'🏢',description:'',display_order:0,subdepartments:[{name:'',description:''}],tags:[''] };

  return (
    <div>
      <div className="admin-header"><h2>Departamentos</h2><button className="btn btn-primary btn-sm" onClick={()=>setEditing(blank)}>+ Nuevo</button></div>
      {msg && <div className="alert alert-success">{msg}</div>}
      {editing && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setEditing(null)}>
          <div className="modal modal-lg fade-in">
            <div className="modal-header"><h3>{editing.id?'Editar departamento':'Nuevo departamento'}</h3><button className="modal-close" onClick={()=>setEditing(null)}>×</button></div>
            <div className="modal-body">
              <div style={{ display:'flex',gap:10 }}>
                <div className="form-group" style={{ flex:'0 0 70px' }}><label className="form-label">Icono</label><input className="form-input" value={editing.icon} onChange={e=>setEditing(d=>({...d,icon:e.target.value}))} style={{ textAlign:'center',fontSize:20 }} /></div>
                <div className="form-group" style={{ flex:1 }}><label className="form-label">Nombre</label><input className="form-input" value={editing.name} onChange={e=>setEditing(d=>({...d,name:e.target.value}))} /></div>
                <div className="form-group" style={{ flex:'0 0 80px' }}><label className="form-label">Orden</label><input className="form-input" type="number" value={editing.display_order} onChange={e=>setEditing(d=>({...d,display_order:+e.target.value}))} /></div>
              </div>
              <div className="form-group"><label className="form-label">Descripción</label><textarea className="form-textarea" rows={3} value={editing.description} onChange={e=>setEditing(d=>({...d,description:e.target.value}))} /></div>
              <div style={{ marginBottom:12 }}>
                <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8 }}><label className="form-label" style={{ margin:0 }}>Subdepartamentos</label><button className="btn btn-outline btn-sm" onClick={()=>setEditing(d=>({...d,subdepartments:[...(d.subdepartments||[]),{name:'',description:''}]}))}>+</button></div>
                {(editing.subdepartments||[]).map((s,i) => (
                  <div key={i} style={{ display:'flex',gap:8,marginBottom:6 }}>
                    <input className="form-input" placeholder="Nombre" value={s.name} style={{ flex:'0 0 160px' }} onChange={e=>{const ss=[...editing.subdepartments];ss[i]={...ss[i],name:e.target.value};setEditing(d=>({...d,subdepartments:ss}));}} />
                    <input className="form-input" placeholder="Descripción" value={s.description} onChange={e=>{const ss=[...editing.subdepartments];ss[i]={...ss[i],description:e.target.value};setEditing(d=>({...d,subdepartments:ss}));}} />
                    <button className="btn-icon" onClick={()=>setEditing(d=>({...d,subdepartments:d.subdepartments.filter((_,j)=>j!==i)}))}>🗑</button>
                  </div>
                ))}
              </div>
              <div>
                <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8 }}><label className="form-label" style={{ margin:0 }}>Etiquetas</label><button className="btn btn-outline btn-sm" onClick={()=>setEditing(d=>({...d,tags:[...(d.tags||[]),''],}))}>+</button></div>
                <div style={{ display:'flex',gap:6,flexWrap:'wrap' }}>
                  {(editing.tags||[]).map((t,i) => (
                    <div key={i} style={{ display:'flex',gap:4,alignItems:'center' }}>
                      <input className="form-input" placeholder="Etiqueta" value={t} style={{ width:120 }} onChange={e=>{const ts=[...editing.tags];ts[i]=e.target.value;setEditing(d=>({...d,tags:ts}));}} />
                      <button className="btn-icon" style={{ padding:4 }} onClick={()=>setEditing(d=>({...d,tags:d.tags.filter((_,j)=>j!==i)}))}>×</button>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ display:'flex',gap:8,justifyContent:'flex-end',marginTop:20 }}>
                <button className="btn btn-outline" onClick={()=>setEditing(null)}>Cancelar</button>
                <button className="btn btn-primary" onClick={save}>Guardar</button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead><tr><th>Departamento</th><th>Subdptos.</th><th>Etiquetas</th><th>Acciones</th></tr></thead>
          <tbody>
            {depts.map(d => (
              <tr key={d.id}>
                <td><span style={{ fontSize:18,marginRight:8 }}>{d.icon}</span><strong>{d.name}</strong></td>
                <td>{d.subdepartments?.length||0}</td>
                <td>{d.tags?.slice(0,3).map((t,i)=><span key={i} className="badge badge-dark" style={{ marginRight:4 }}>{t}</span>)}</td>
                <td><div className="actions"><button className="btn-icon" onClick={()=>setEditing({...d,subdepartments:d.subdepartments||[],tags:d.tags||[]})}>✏️</button><button className="btn-icon" onClick={()=>del(d.id)}>🗑</button></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── SECCIÓN CONTRASEÑAS ──────────────────────────────────────
function AdminAccesos({ authFetch }) {
  const [portalPwd, setPortalPwd] = useState({ new:'', confirm:'' });
  const [adminPwd, setAdminPwd]   = useState({ current:'', new:'', confirm:'' });
  const [msg, setMsg] = useState({ text:'', type:'' });
  const toast = (text, type='success') => { setMsg({text,type}); setTimeout(()=>setMsg({text:'',type:''}),4000); };

  const savePortal = async e => {
    e.preventDefault();
    if (portalPwd.new !== portalPwd.confirm) return toast('Las contraseñas no coinciden','error');
    if (portalPwd.new.length < 4) return toast('Mínimo 4 caracteres','error');
    const res = await authFetch('/api/auth/change-portal-password',{method:'POST',body:JSON.stringify({newPassword:portalPwd.new})});
    const d = await res.json();
    if (d.ok) { toast('✅ Contraseña del portal actualizada'); setPortalPwd({new:'',confirm:''}); }
    else toast(d.error||'Error','error');
  };

  const saveAdmin = async e => {
    e.preventDefault();
    if (adminPwd.new !== adminPwd.confirm) return toast('Las contraseñas no coinciden','error');
    if (adminPwd.new.length < 6) return toast('Mínimo 6 caracteres','error');
    const res = await authFetch('/api/auth/change-password',{method:'POST',body:JSON.stringify({currentPassword:adminPwd.current,newPassword:adminPwd.new})});
    const d = await res.json();
    if (d.ok) { toast('✅ Contraseña de admin actualizada'); setAdminPwd({current:'',new:'',confirm:''}); }
    else toast(d.error||'Error','error');
  };

  return (
    <div>
      <div className="admin-header"><h2>Contraseñas de acceso</h2></div>
      {msg.text && <div className={`alert alert-${msg.type==='error'?'error':'success'}`}>{msg.text}</div>}

      {/* Contraseña del portal (empleados) */}
      <div className="card" style={{ marginBottom:16 }}>
        <h3 style={{ fontWeight:600, marginBottom:4 }}>🔑 Contraseña del portal (empleados)</h3>
        <p style={{ fontSize:13, color:'var(--mid)', marginBottom:16, lineHeight:1.6 }}>
          Esta es la contraseña que los nuevos empleados deben introducir para acceder al portal.
          Puedes compartirla con RR.HH. o directamente con el empleado.
        </p>
        <form onSubmit={savePortal}>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Nueva contraseña de acceso</label>
              <input className="form-input" type="password" placeholder="Mínimo 4 caracteres" value={portalPwd.new} onChange={e=>setPortalPwd(p=>({...p,new:e.target.value}))} required />
            </div>
            <div className="form-group">
              <label className="form-label">Confirmar contraseña</label>
              <input className="form-input" type="password" placeholder="Repite la contraseña" value={portalPwd.confirm} onChange={e=>setPortalPwd(p=>({...p,confirm:e.target.value}))} required />
            </div>
          </div>
          <button className="btn btn-primary btn-sm" type="submit">Actualizar contraseña del portal</button>
        </form>
      </div>

      {/* Contraseña del admin */}
      <div className="card">
        <h3 style={{ fontWeight:600, marginBottom:4 }}>⚙️ Contraseña del panel admin</h3>
        <p style={{ fontSize:13, color:'var(--mid)', marginBottom:16, lineHeight:1.6 }}>
          Contraseña del usuario <strong>admin</strong> para acceder a este panel de administración.
          Mantenla segura y no la compartas.
        </p>
        <form onSubmit={saveAdmin}>
          <div className="form-group">
            <label className="form-label">Contraseña actual</label>
            <input className="form-input" type="password" value={adminPwd.current} onChange={e=>setAdminPwd(p=>({...p,current:e.target.value}))} required style={{ maxWidth:360 }} />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Nueva contraseña</label>
              <input className="form-input" type="password" placeholder="Mínimo 6 caracteres" value={adminPwd.new} onChange={e=>setAdminPwd(p=>({...p,new:e.target.value}))} required />
            </div>
            <div className="form-group">
              <label className="form-label">Confirmar</label>
              <input className="form-input" type="password" value={adminPwd.confirm} onChange={e=>setAdminPwd(p=>({...p,confirm:e.target.value}))} required />
            </div>
          </div>
          <button className="btn btn-primary btn-sm" type="submit">Actualizar contraseña admin</button>
        </form>
      </div>
    </div>
  );
}
